module.exports = __webpack_public_path__ + "img/h_s1e2_gallery_3.265b8621.png";